import React, { useEffect, useRef } from 'react';
import get from 'lodash/get';
import isEqual from 'react-fast-compare';

import colors from '@utils/colors';
import { useIntl } from '@utils/localize';
import Checkbox from '@components/Checkbox';
import Container from '@components/Container';
import { ChevronDown, Search } from '@components/Icon';
import * as styled from './styles';

function Desktop({
  controller,
  filters,
  handleFilter,
  handleSearch,
  handleSort,
  search,
  sort,
}) {
  const intl = useIntl();
  const searchInput = useRef(null);

  const searchInputProps = {
    onChange: handleSearch,
    placeholder: search.placeholder || search.title,
  };

  if (search.value) {
    searchInputProps.defaultValue = search.value;
  }

  useEffect(() => {
    if (controller.state.search === '' && searchInput.current) {
      searchInput.current.value = '';
    }
  }, [controller]);

  return (
    <Container centered>
      <styled.Wrapper>
        <styled.Search>
          <styled.SearchInput {...searchInputProps} ref={searchInput} aria-label={search.title} />
          <Search color={colors.B500} />
        </styled.Search>
        {(filters || []).map((filter, idx) => {
          const filterValues = get(
            controller,
            `state.filter['${filter.key}']`,
            [],
          );

          return (
            <styled.Section key={idx}>
              <styled.Heading level={500}>
                {filter.title}{' '}
                {filterValues.length > 0 ? `(${filterValues.length})` : ''}
              </styled.Heading>
              <styled.Dropdown>
                {filter.items.map((item, idx) => (
                  <styled.Item key={idx}>
                    <Checkbox
                      checked={filterValues.includes(item.value)}
                      label={item.name}
                      onChange={() => {
                        handleFilter(filter.key, item.value);
                      }}
                    />
                  </styled.Item>
                ))}
              </styled.Dropdown>
              <ChevronDown color={colors.B500} />
            </styled.Section>
          );
        })}
        {sort && (
          <styled.Section>
            <styled.Heading level={500}>{intl.formatMessage({ id: 'sortBy' })}</styled.Heading>
            <styled.Dropdown>
              {sort.options.map((option, idx) => (
                <styled.Item key={idx}>
                  <Checkbox
                    checked={isEqual(controller.state.sort, option.value)}
                    label={option.name}
                    onChange={() => {
                      handleSort(option.value);
                    }}
                  />
                </styled.Item>
              ))}
            </styled.Dropdown>
            <ChevronDown color={colors.B500} />
          </styled.Section>
        )}
      </styled.Wrapper>
    </Container>
  );
}

export default Desktop;
